import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import { Button, Modal, Table } from "antd";
import BaseCard from "../../components/card/BaseCard";
import BaseTable from "../../components/BaseTable";
import type { TableProps } from "antd/lib";
import ButtonIcon from "../../components/ButtonIcon";
import { $api, type components } from "../../helper";
import ImageCard from "../../components/card/ImageCard";
import PreviewFile from "../../components/PreviewFile";
import { tokenMock } from "../../helper/mock";
import { GetFullMediaPath } from "../../helper/method";
import { useNotify } from "../../helper/notify";
import FormItemInputTextarea from "../../components/form-item/form-item-input-textarea";
import ButtonIconSvg from "../../components/ButtonIconSvg";
import PenSquare from "../../components/svg/PenSquare";

export default function Setting() {
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState("");
  const notify = useNotify();
  const { data, isLoading, refetch } = $api.useQuery(
    "get",
    "/site-api/v1/setting/",
  );
  const detail = $api.useMutation("get", "/site-api/v1/setting-detail/");
  const update = $api.useMutation("put", "/site-api/v1/setting/");
  const [key, setKey] = useState("");
  const [file, setFile] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("تنظیمات");
  }, []);

  useEffect(() => {
    if (key) {
      detail.mutate(
        {
          params: {
            query: {
              setting_u_id: key,
            },
          },
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            if (data.data.type === 2) {
              setFile([
                {
                  file: undefined,
                  fileUrl: GetFullMediaPath(data.data.value ?? ""),
                  id: data.data.u_id,
                },
              ]);
            } else {
              setValue(data.data.value ?? "");
            }
          },
        },
      );
    }
  }, [key]);

  const columns: TableProps<
    components["schemas"]["SiteSettingItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "عنوان تنظیمات",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "مقدار",
      dataIndex: "value",
      key: "value",
      render: (_, record) =>
        record.type === 2 ? (
          <div className="aspect-square w-16 rounded-lg overflow-hidden">
            <img
              src={GetFullMediaPath(record.value ?? "")}
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
        ) : (
          <span className="">{record.value}</span>
        ),
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex">
          {/* <ButtonIcon
            onClick={() => {
              setIsOpen(true);
              setKey(record.u_id);
            }}
            icon="solar:pen-new-square-linear"
            className="text-primary-500!"
          /> */}
          <ButtonIconSvg
            icon={<PenSquare />}
            onClick={() => {
              setIsOpen(true);
              setKey(record.u_id);
            }}
            className="text-primary-500!"
          />
        </div>
      ),
    },
  ];

  const onFinish = () => {
    const formData = new FormData();
    formData.append("setting_u_id", key);
    if (detail.data?.data.type === 2) {
      file.forEach((element) => {
        formData.append("value", element.file ?? element.fileUrl);
      });
    } else {
      formData.append("value", value);
    }
    update.mutate(
      {
        body: formData,
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      },
      {
        onSuccess: (data) => {
          notify.success(data.message);
          setIsOpen(false);
          setKey("");
          refetch();
        },
      },
    );
  };

  return (
    <div className="flex flex-col gap-6">
      {/* modal */}
      <Modal
        loading={detail.isPending}
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        title="تنظیمات"
        footer={null}
        closeIcon={false}
        classNames={{ body: "flex flex-col gap-4" }}
      >
        {data?.data
          ?.filter((e) => e.u_id === key)
          ?.map((e, i) =>
            e.type === 2 ? (
              <div className="flex flex-col gap-2">
                <ImageCard
                  key={i + "content-modal"}
                  file={file}
                  id="sdfcdf"
                  name="ddddddd"
                  setFile={setFile}
                />
                {file?.map((e, i) => (
                  <div className="aspect-square w-40">
                    <PreviewFile
                      setFile={setFile}
                      url={e.fileUrl}
                      id={e.id}
                      key={i + e.id}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="flex flex-col gap-2">
                <FormItemInputTextarea
                  inputProps={{
                    value: value,
                    onChange: (e) => setValue(e.target.value),
                  }}
                />
              </div>
            ),
          )}
        <div className="flex gap-2">
          <Button onClick={onFinish} loading={update.isPending} type="primary">
            ذخیره
          </Button>
          <Button type="primary" danger onClick={() => setIsOpen(false)}>
            لغو
          </Button>
        </div>
      </Modal>
      <BaseCard props={{ className: "flex-1 flex-col flex gap-6" }}>
        <BaseTable props={{ className: "w-full grid! grid-cols-1!" }}>
          <Table<components["schemas"]["SiteSettingItem"]>
            loading={isLoading}
            className="col-span-1!"
            scroll={{ x: "max-content" }}
            columns={columns}
            dataSource={data?.data}
          />
        </BaseTable>
      </BaseCard>
    </div>
  );
}
